<template>
  <div>
    <a-toolbar class="primary-gradient pl-4">
      <v-icon left dark> mdi-label-variant </v-icon>
      <span class="widget-title">{{
        $t("widget.PowerBIWidgetTitle")
      }} </span>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="$security.checkUserAccess('ViewAdmin')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="$security.checkUserAccess('ViewAdmin')"
            v-bind="attrs"
            v-on="on"
            icon
            small
            class="mr-2"
            @click="refreshEmbedReport"
          >
            <v-icon color="white">mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>{{
        $t("lblRefresh")
      }}</span>
      </v-tooltip>
    </a-toolbar>
    <v-card color="Neutral" class="time-allocation-card overflow-y-auto">
      <div class="report-container">
      <div ref="reportContainer" id="reportContainer"></div>
    </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import irService from "../../../api/IRService";
export default {
  name: "PowerBIWidget",
  components: {
  },
  data() {
    return {
    };
  },
computed: {
  ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
    }),
},
async mounted() {
    await this.loadPowerBISDK()
      .then(() => {
        this.embedReport();
      })
      .catch((error) => {
        console.error("Error loading Power BI SDK:", error);
      });
  },
  methods: {
    refreshEmbedReport() {
      this.embedReport(true);
    },
    async loadPowerBISDK() {
      return new Promise((resolve, reject) => {
        if (window.powerbi) {
          resolve();
          console.log("loadPowerBISDK : IF");
        } else {
          console.log("loadPowerBISDK : Else");
          const script = document.createElement("script");
          script.src = "https://cdn.jsdelivr.net/npm/powerbi-client/dist/powerbi.min.js";
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        }
      });
    },
    async handleRefresh() {
        const result = await irService.RefreshPowerBIReport();
        return result;
      },
    async embedReport(isRefresh = false) {
      try {
        let response = null;
        const PowerBIDetails = this.tenantSettingTypes("PowerBIIntegrationDetails");
        console.log("PowerBIDetails", PowerBIDetails);
        if(PowerBIDetails.length==0)
        {
          console.log("PowerBIIntegrationDetails is empty");
          this.$store.commit("setAlert", {
            variant: "error",
            message: this.$t("widget.PowerBIIntegrationDetailsConfAbsent"),
          });
          return false;
        }

        const requiredKeys = [
          "ext_report_id",
          "ext_sp_client_id",
          "ext_sp_client_secret",
          "ext_sp_tenant_id",
          "ext_workspace_id",
          "tb_sp_client_id",
          "tb_sp_client_secret",
          "tb_sp_tenant_id",
          "tb_workspace_id"
        ];

        const hasAllValues = requiredKeys.every(
          key => typeof PowerBIDetails[key] === "string" && PowerBIDetails[key].trim().length > 0
        );

        if (isRefresh) {
          response = await this.handleRefresh();
        } else if (hasAllValues) {
          response = !PowerBIDetails.report_id
            ? await this.handleRefresh()
            : await irService.getPowerBIReport();
        }
        else
        {
          this.$store.commit("setAlert", {
            variant: "error",
            message: this.$t("widget.PowerBIDetailsAbsent"),
          });
            return;
        }

        if(!response)
        {
          this.$store.commit("setAlert", {
            variant: "error",
            message: this.$t("widget.PowerBIReportResponseBlank"),
          });
          return;
        }
        
        const embedInfo = await response.data;
        
        const embedConfig = {
          type: "report",
          id: embedInfo.reportId,
          embedUrl: embedInfo.embedUrl,
          accessToken: embedInfo.embedToken,
          tokenType: window["powerbi-client"].models.TokenType.Embed,
          settings: {
            panes: {
              filters: { visible: false },
              pageNavigation: { visible: true }
            }
          }
        };

        const reportContainer = this.$refs.reportContainer;
        window.powerbi.embed(reportContainer, embedConfig);
      } catch (error) {
        console.error("Power BI Widget : Error embedding report:", error);
      }
    }
  },
};

</script>

<style>
.report-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}

#reportContainer {
  width: 100%;
  height: 600px;
  border: none;
}
</style>